import { render } from "./CrossReference.vue?vue&type=template&id=e2627348&scoped=true"
import script from "./CrossReference.vue?vue&type=script&lang=js"
export * from "./CrossReference.vue?vue&type=script&lang=js"

import "./CrossReference.vue?vue&type=style&index=0&id=e2627348&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2627348"]])

export default __exports__